import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {useWindowSize} from 'react-use';
import '../../styles/application/Home.scss';
import Carousel from 'react-material-ui-carousel';

import B1 from '../../image/banners/home/b1.jpg';
import B2 from '../../image/banners/home/b2.jpg';
import B3 from '../../image/banners/home/b3.jpg';
import B4 from '../../image/banners/home/b4.jpg';
import B5 from '../../image/banners/home/b5.jpg';
import B6 from '../../image/banners/home/b6.jpg';
import B7 from '../../image/banners/customisation.jpg';

import Unisex from '../../image/apperals/unisex.jpg';
import Mens from '../../image/apperals/mens.jpg';
import Womens from '../../image/apperals/womens.jpg';
import Kids from '../../image/apperals/kids.jpg';

import MobileCase from '../../image/accessories/mobilecase.jpg';
import PopGrip from '../../image/accessories/popgrip.jpg';
import Badge from '../../image/accessories/badge.jpg';
import Mug from '../../image/accessories/mug.jpg';
import SipperBottle from '../../image/accessories/sipperbottle.jpg';
import ToteBag from '../../image/accessories/totebag.jpg';
import Coaster from '../../image/accessories/coaster.jpg';
import MousePad from '../../image/accessories/mousepad.jpg';
import NotePad from '../../image/accessories/notepad.jpg';

import Canvas from '../../image/decors/canvas.jpg';
import PhotoFrame from '../../image/decors/photoframe.jpg';
import Poster from '../../image/decors/poster.jpg';
// import DreamCatcher from '../../image/decors/dreamcatcher.jpg';

import Box from '../../image/info/box.svg';
import DeliveryTruck from '../../image/info/delivery-truck.svg';
import India from '../../image/info/india.svg';
import Package from '../../image/info/package.svg';
import {ACCESSORIES_INFO, DECORS_INFO} from '../../utils/Constants';
import useDocSetup from '../../hooks/useDocSetup';

function Home() {
  useDocSetup('Home');

  const {width} = useWindowSize();

  const altText = '🔄 Please reload the site ❗';

  const banners = [
    {img: B1, link: '/apparels/allover_men'},
    {img: B2, link: '/accessories/mobilecase'},
    {img: B3, link: '/apparels/rhalf'},
    {img: B4, link: '/bulkorders'},
    {img: B5, link: '/apparels/sweatshirt'},
    {img: B6, link: '/decors/photoframe'},
  ];

  const apparels = [
    {
      path: '/t/unisex',
      src: Unisex,
    },
    {
      path: '/t/mens',
      src: Mens,
    },
    {
      path: '/t/womens',
      src: Womens,
    },
    {
      path: '/t/kids',
      src: Kids,
    },
  ];

  const infoSvgs = [
    {src: Box, label: 'Securely Packed'},
    {src: DeliveryTruck, label: 'Free Shipping'},
    {src: India, label: 'Home Grown Indian Products'},
    {src: Package, label: 'On-Time Delivery'},
  ];

  const accessories = [
    {
      path: ACCESSORIES_INFO['mobilecase'].path,
      src: MobileCase,
    },
    {
      path: ACCESSORIES_INFO['popgrip'].path,
      src: PopGrip,
    },
    {
      path: ACCESSORIES_INFO['badge'].path,
      src: Badge,
    },
    {
      path: ACCESSORIES_INFO['mug'].path,
      src: Mug,
    },
    {
      path: ACCESSORIES_INFO['sipperbottle'].path,
      src: SipperBottle,
    },
    {
      path: ACCESSORIES_INFO['totebag'].path,
      src: ToteBag,
    },
    {
      path: ACCESSORIES_INFO['coaster'].path,
      src: Coaster,
    },
    {
      path: ACCESSORIES_INFO['mousepad'].path,
      src: MousePad,
    },
    {
      path: ACCESSORIES_INFO['notepad'].path,
      src: NotePad,
    },
  ];

  const decors = [
    {
      path: DECORS_INFO['canvas'].path,
      src: Canvas,
    },
    {
      path: DECORS_INFO['photoframe'].path,
      src: PhotoFrame,
    },
    {
      path: DECORS_INFO['poster'].path,
      src: Poster,
    },
    // {
    //   path: DECORS_INFO['dreamcatcher'].path,
    //   src: DreamCatcher,
    // },
  ];

  const [showCarousel, setShowCarousel] = useState(false);

  useEffect(() => {
    setShowCarousel(true);
    return () => {
      setShowCarousel(false);
    };
  }, []);

  return (
    <div className="home">
      <div className="home_container">
        {showCarousel && (
          <div
            className="home_carousel"
            style={
              width >= 1636 && width < 2048
                ? {height: '43rem'}
                : width >= 2048 && width < 2300
                ? {height: '48rem'}
                : width >= 2300
                ? {height: '50rem'}
                : {}
            }
          >
            <Carousel
              indicators={false}
              animation="slide"
              fullHeightHover={true}
            >
              {banners.map((b, i) => (
                <Link to={b.link} key={i}>
                  <img src={b.img} alt={altText} />
                </Link>
              ))}
            </Carousel>
          </div>
        )}
        <div className="home_categoryRow">
          <div
            className="home_categoryRow_Tilte"
            style={
              width > 769
                ? {marginTop: '-16rem'}
                : width < 1024 && width > 769
                ? {marginTop: '-10rem'}
                : {marginTop: '0'}
            }
          >
            <div className="home_Title_Line"></div>
            <span>Apparels</span>
            <div className="home_Title_Line"></div>
          </div>
          <div className="home_categoryCard_group">
            {apparels.map((apparel, i) => (
              <div
                className="home_apparelsCard"
                key={i}
                style={
                  width > 1370
                    ? {height: '13.5rem'}
                    : width <= 1370 && width > 1024
                    ? {height: '13rem'}
                    : width <= 1024 && width > 769
                    ? {height: '10rem'}
                    : {height: '6rem'}
                }
              >
                <Link to={apparel.path}>
                  <img src={apparel.src} alt={altText} />
                </Link>
              </div>
            ))}
          </div>
        </div>
        <div className="home_Info_Row">
          {infoSvgs.map((infoSvg, i) => (
            <div className="home_Info_svg" key={i}>
              <img src={infoSvg.src} alt={altText} />
              <span>{infoSvg.label}</span>
            </div>
          ))}
        </div>
        <div className="home_categoryRow">
          <div className="home_categoryRow_Tilte">
            <div className="home_Title_Line"></div>
            <span>Accessories</span>
            <div className="home_Title_Line"></div>
          </div>
          <div className="home_categoryCard_group" style={{flexWrap: 'wrap'}}>
            {accessories.map((accessory, i) => (
              <div className="home_accessoryCard" key={i}>
                <Link to={accessory.path}>
                  <img src={accessory.src} alt={altText} />
                </Link>
              </div>
            ))}
          </div>
        </div>
        <div className="home_Info_Row">
          <div className="home_Info_Poster1">
            <a
              href="https://wa.me/message/3Y2HB67W46SNO1"
              target="_blank"
              rel="noreferrer"
              title="Whatsapp Us❗"
            >
              <img src={B7} alt={altText} />
            </a>
          </div>
        </div>
        <div className="home_categoryRow">
          <div className="home_categoryRow_Tilte">
            <div className="home_Title_Line"></div>
            <span>DECORS </span>
            <div className="home_Title_Line"></div>
          </div>
          <div className="home_categoryCard_group">
            {decors.map((decor, i) => (
              <div className="home_decorCard" key={i}>
                <Link to={decor.path}>
                  <img src={decor.src} alt={altText} />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
